import { render, staticRenderFns } from "./AdminAddActivityDurationTypeModal.vue?vue&type=template&id=2e5814bf&"
import script from "./AdminAddActivityDurationTypeModal.vue?vue&type=script&lang=js&"
export * from "./AdminAddActivityDurationTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports